module.exports = __webpack_public_path__ + "static/media/game_loading_bg.52e48c2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/game_loading_bg.png
// module id = 582
// module chunks = 1 7